import React from 'react';
import AccountSetupModal from '../../../AccountSetupModal';

/**
 * Renders the existing account-setup workflow inside its dedicated tab.
 *
 * @param {object} props
 * @param {string} props.companyId
 * @param {Function} props.onClose
 */
export const AccountSetupTab = ({ companyId, onClose }) => (
    <AccountSetupModal companyId={companyId} isEmbedded={true} onClose={onClose} />
);
